export default __webpack_public_path__ + "449052b9a142eabd6684b72d4416806f.png";